const validAMVACity: { id: string, value: string }[] = [
    { id: "5079", value: "BARBOSA" },
    { id: "5088", value: "BELLO" },
    { id: "5129", value: "CALDAS" },
    { id: "5212", value: "COPACABANA" },
    { id: "5266", value: "ENVIGADO" },
    { id: "5308", value: "GIRARDOTA" },
    { id: "5360", value: "ITAGUI" },
    { id: "5380", value: "LA ESTRELLA" },
    { id: "5001", value: "MEDELLIN" },
    { id: "5631", value: "SABANETA" },
    { id: "5376", value: "LA CEJA" },
    { id: "5607", value: "RETIRO" },
    { id: "5615", value: "RIONEGRO" }
];

export const validateCity = (id: string): boolean => {
    return validAMVACity.some(city => city.id == id);
};